export default "__VITE_ASSET__DSrbvn2___"